import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { buildHttpParams } from 'src/app/shared/query-utils'
import { ResourceService } from 'src/app/shared/resource-service'
import { environment } from 'src/environments/environment'

import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { RequestQueryBuilder } from '@nestjsx/crud-request'

import { PaginatedResponse } from '../../../shared/interfaces'
import { Payment } from './payment'
import { PaymentSerializer } from './payment.serializer'

@Injectable()
export class PaymentService extends ResourceService<Payment> {
  constructor(
    private http: HttpClient,
    private paymentSerializer: PaymentSerializer
  ) {
    super(http, `${environment.backendApiUrl}/payments`, paymentSerializer)
  }

  public getManyByMemberId(
    memberId: number,
    params?: RequestQueryBuilder
  ): Observable<Payment[]> {
    return this.http
      .get<PaginatedResponse>(
        `${environment.backendApiUrl}/members/${memberId}/payments`,
        {
          params: buildHttpParams(params)
        }
      )
      .pipe(
        map((reponse) =>
          reponse.data.map(
            (data: any) => this.paymentSerializer.fromJson(data) as Payment
          )
        )
      )
  }
}
